import { Box, CircularProgress } from '@mui/material';

const Loader = () => (
  <Box
    sx={{
      textAlign: 'center',
      display: 'grid',
      placeItems: 'center',
      height: '100vh',
    }}
  >
    <CircularProgress size={200} thickness={1} />
  </Box>
);

export default Loader;
